import { CardFeesInstallment } from '@/model/CardFeesInstallment';
import { unmask, updateMask } from './masks/cashNumber';
import { toPercentage } from './common/amount';

export interface InstallmentFeeInput {
  installment: number;
  fee: string;
}

// useForm stores string values; keep the list in one field so reset and validation
// follow the same lifecycle as the rest of each configuration form.
export const readInstallmentInputs = (value = '[]'): InstallmentFeeInput[] =>
  JSON.parse(value || '[]');

export const loadInstallmentFees = (fees: CardFeesInstallment[] = []): string =>
  JSON.stringify(
    [...fees]
      .sort((a, b) => a.installment - b.installment)
      .map(item => ({
        installment: Number(item.installment),
        fee: updateMask((Number(item.fee) * 100).toFixed(0)),
      })),
  );

export const validateInstallmentFees = (value = '[]'): string | false => {
  try {
    const items = readInstallmentInputs(value);
    if (
      !Array.isArray(items) ||
      items.some(
        item =>
          !Number.isInteger(item.installment) ||
          item.installment < 1 ||
          typeof item.fee !== 'string' ||
          item.fee.trim() === '' ||
          !Number.isFinite(Number(unmask(item.fee))) ||
          Number(unmask(item.fee)) < 0,
      ) ||
      new Set(items.map(item => item.installment)).size !== items.length
    ) {
      return 'Informe parcelas únicas e taxas válidas, maiores ou iguais a zero.';
    }
    return false;
  } catch {
    return 'Configuração de parcelas inválida.';
  }
};

export const saveInstallmentFees = (value = '[]'): CardFeesInstallment[] => {
  const error = validateInstallmentFees(value);
  if (error) throw new Error(error);
  return readInstallmentInputs(value)
    .map(item => ({
      installment: item.installment,
      fee: Number(unmask(item.fee)),
    }))
    .sort((a, b) => a.installment - b.installment);
};

export const validateCardFee = (value = ''): string | false => {
  const number = Number(unmask(value));
  return value.trim() !== '' && Number.isFinite(number) && number >= 0 && number <= 99.99
    ? false
    : 'Informe uma taxa entre 0 e 99,99.';
};

export const formatInstallmentFees = (fees: CardFeesInstallment[] = []): string =>
  fees.length
    ? [...fees]
        .sort((a, b) => a.installment - b.installment)
        .map(item => `${item.installment}x: ${toPercentage(item.fee)}%`)
        .join(' | ')
    : 'Sem parcelas';
